var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "OrderDetcontent" },
    [
      _vm.orderDetail
        ? _c(
            "van-row",
            [
              _c(
                "van-col",
                { staticClass: "cardBar", attrs: { span: "24" } },
                [
                  _c(
                    "van-row",
                    { staticClass: "InfoCard" },
                    [
                      _c(
                        "van-col",
                        { staticClass: "cardNumber", attrs: { span: "24" } },
                        [
                          _vm._v("卡号："),
                          _c("span", { staticClass: "number" }, [
                            _vm._v(_vm._s(_vm.orderDetail.userCardNumber))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "address", attrs: { span: "24" } },
                        [_vm._v(_vm._s(_vm.orderDetail.address))]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "name", attrs: { span: "12" } },
                        [_vm._v(_vm._s(_vm.orderDetail.userName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "area textR", attrs: { span: "12" } },
                        [_vm._v("用热面积：" + _vm._s(_vm.orderDetail.useArea))]
                      ),
                      _vm._v(" "),
                      _vm.orderDetail.status == 0
                        ? _c(
                            "van-col",
                            { staticClass: "money", attrs: { span: "12" } },
                            [_vm._v("待缴总金额")]
                          )
                        : _c(
                            "van-col",
                            { staticClass: "money", attrs: { span: "12" } },
                            [_vm._v("已缴总金额")]
                          ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "money textR", attrs: { span: "12" } },
                        [
                          _c("span", [
                            _vm._v("¥ " + _vm._s(_vm.orderDetail.money))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { attrs: { span: "24" } },
                _vm._l(_vm.orderDetailList, function(itemN, index) {
                  return _vm.orderDetailList
                    ? _c(
                        "van-row",
                        { key: index, staticClass: "billBar" },
                        [
                          _c(
                            "van-col",
                            { staticClass: "title", attrs: { span: "24" } },
                            [
                              _c("i", { staticClass: "icon" }),
                              _vm._v(_vm._s(itemN.createTime))
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "van-col",
                            { staticClass: "cont", attrs: { span: "24" } },
                            [
                              _c(
                                "van-col",
                                {
                                  staticClass: "orange bill-money",
                                  attrs: { span: "14" }
                                },
                                [
                                  _vm._v(
                                    "本采暖季费用：" +
                                      _vm._s(itemN.money ? itemN.money : "0") +
                                      "元"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "van-col",
                                {
                                  staticClass: "bill-money textR",
                                  attrs: { span: "10" }
                                },
                                [
                                  _vm._v(
                                    "单价：" + _vm._s(itemN.price) + "元/m"
                                  ),
                                  _c("sup", [_vm._v("2")])
                                ]
                              ),
                              _vm._v(" "),
                              _c("van-col", { attrs: { span: "14" } }, [
                                _vm._v(
                                  "退费金额：" +
                                    _vm._s(
                                      itemN.refundMoney
                                        ? itemN.refundMoney
                                        : "0"
                                    ) +
                                    "元"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "van-col",
                                { staticClass: "textR", attrs: { span: "10" } },
                                [
                                  _vm._v(
                                    "优惠：" +
                                      _vm._s(
                                        itemN.benefitMoney
                                          ? itemN.benefitMoney
                                          : "0"
                                      ) +
                                      "元"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass: "barBtn",
                  attrs: { span: "24", type: "flex", justify: "space-between" }
                },
                [
                  _vm.orderDetail.status == 0
                    ? _c(
                        "van-button",
                        {
                          staticClass: "btn",
                          attrs: { round: "", type: "danger", size: "large" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.goPayment()
                            }
                          }
                        },
                        [_vm._v("去缴费")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderDetail.status == 5
                    ? _c(
                        "van-button",
                        {
                          staticClass: "btn",
                          attrs: { round: "", type: "danger", size: "large" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.goSearch()
                            }
                          }
                        },
                        [_vm._v("查询状态")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c(
            "van-row",
            { staticClass: "noPayBar" },
            [
              _c("van-col", { staticClass: "noPayPC", attrs: { span: "24" } }),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "text1 orange", attrs: { span: "24" } },
                [_vm._v("没有找到该用户！")]
              ),
              _vm._v(" "),
              _c("van-col", { staticClass: "text2", attrs: { span: "24" } }, [
                _vm._v("去试试【自主信息填写缴费】吧！")
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d19ca2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d19ca2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/OrderDetail.vue
// module id = null
// module chunks = 